import * as React from "react";
const SvgMinimizeIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 19H18V21H6V19Z", fill: "currentColor" }));
export default SvgMinimizeIcon;
